import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/api";

export default function AdminReset() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Parolele nu coincid");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Link invalid sau expirat");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6" data-testid="admin-reset-page">
      <div className="w-full max-w-sm bg-cream-light border border-warm-grey/50 rounded-3xl p-8 shadow-xl shadow-main/5">
        <img src="/assets/logo-line.webp" alt="Imperfect House" className="h-10 w-auto mix-blend-multiply" />
        <h1 className="mt-6 font-serif text-3xl text-main">Parolă nouă</h1>
        {done ? (
          <div className="mt-6" data-testid="reset-success">
            <p className="text-sm text-green-dark font-semibold">Parola a fost schimbată cu succes.</p>
            <Link to="/admin/login" className="mt-6 block rounded-full bg-main text-cream-light text-center font-semibold py-3.5 hover:bg-terracotta transition-colors" data-testid="reset-login-link">
              Intră în cont
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="reset-form">
            <input
              type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Parolă nouă (min. 8 caractere)" data-testid="reset-password"
              className="w-full bg-cream border border-warm-grey/60 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta/50"
            />
            <input
              type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
              placeholder="Confirmă parola" data-testid="reset-confirm"
              className="w-full bg-cream border border-warm-grey/60 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta/50"
            />
            {error && <p className="text-sm text-terracotta font-semibold" data-testid="reset-error">{error}</p>}
            <button type="submit" disabled={loading || !token} data-testid="reset-submit"
              className="w-full rounded-full bg-main text-cream-light font-semibold py-3.5 hover:bg-terracotta disabled:opacity-50 transition-colors">
              {loading ? "Se salvează…" : "Schimbă parola"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
